var map = {
	"./common/patch-giftbox": 18,
	"./common/patch-giftbox.es": 18,
	"./common/patch-giftbox.es.js": 18,
	"./common/patch-join-form": 19,
	"./common/patch-join-form.es": 19,
	"./common/patch-join-form.es.js": 19,
	"./common/patch-liveshow-translator": 20,
	"./common/patch-liveshow-translator.es": 20,
	"./common/patch-liveshow-translator.es.js": 20,
	"./common/patch-newsletter-subscribe": 21,
	"./common/patch-newsletter-subscribe.es": 21,
	"./common/patch-newsletter-subscribe.es.js": 21,
	"./common/patch-store-buy": 22,
	"./common/patch-store-buy.es": 22,
	"./common/patch-store-buy.es.js": 22,
	"./common/patch-tips-form": 23,
	"./common/patch-tips-form.es": 23,
	"./common/patch-tips-form.es.js": 23,
	"./common/register-member-tplenv": 11,
	"./common/register-member-tplenv.es": 11,
	"./common/register-member-tplenv.es.js": 11,
	"./common/register-pager-simple-tpls": 12,
	"./common/register-pager-simple-tpls.es": 12,
	"./common/register-pager-simple-tpls.es.js": 12,
	"./common/show-gdpr-popup": 13,
	"./common/show-gdpr-popup.es": 13,
	"./common/show-gdpr-popup.es.js": 13,
	"./free": 35,
	"./free.es": 35,
	"./free.es.js": 35,
	"./guest": 36,
	"./guest.es": 36,
	"./guest.es.js": 36,
	"./guest/register-joinform-prepareapi": 24,
	"./guest/register-joinform-prepareapi.es": 24,
	"./guest/register-joinform-prepareapi.es.js": 24,
	"./guest/register-joinform-upgrade-oneclick": 25,
	"./guest/register-joinform-upgrade-oneclick.es": 25,
	"./guest/register-joinform-upgrade-oneclick.es.js": 25,
	"./guestActual": 37,
	"./guestActual.es": 37,
	"./guestActual.es.js": 37,
	"./liveshow": 76,
	"./liveshow.js": 76,
	"./member": 38,
	"./member.es": 38,
	"./member.es.js": 38
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 841;


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/user-access/widget/rules ^\.\/.*$
// module id = 841
// module chunks = 4